import React from "react";

const NUmbers = () => {
  return (
    <section className="numbers" id="About">
      <div>
        <h3>1287+</h3>
        <p>SAVINGS</p>
      </div>
      <div>
        <h3>5786+</h3>
        <p>PHOTOS</p>
      </div>
      <div>
        <h3>1440+</h3>
        <p>ROCKETS</p>
      </div>
      <div>
        <h3>7110+</h3>
        <p> GLOBES</p>
      </div>
    </section>
  );
};

export default NUmbers;
